"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StandardTableCell = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _TableProps = require("../TableProps");
var _formFieldPropTypes = require("../../../../propTypes/formFieldPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const StandardTableCell = props => {
  const {
    column,
    value
  } = props;
  const {
    dataType = 'text',
    options
  } = column;
  let adjustedValue = value || '&nbsp;';
  if (dataType === 'boolean') {
    adjustedValue = value === 1 ? 'true' : 'false';
  }
  if (dataType === 'options') {
    adjustedValue = options.find(option => option.value === value || option.value === value.value).label;
  }
  return /*#__PURE__*/_react.default.createElement("span", null, adjustedValue);
};
exports.StandardTableCell = StandardTableCell;
StandardTableCell.propTypes = {
  value: _propTypes.default.oneOfType(_formFieldPropTypes.ValuePropTypes),
  column: _propTypes.default.shape(_TableProps.TableColumnProps)
};
var _default = exports.default = {
  StandardTableCell
};